import { useContext } from 'react';
import WindowEventContext from '../context/window-event-context';
export default function useOnKeyDown(itemId, extractor) {
    if (extractor === void 0) { extractor = function (evt) { return evt.target.value; }; }
    var _onFieldUpdate = useContext(WindowEventContext)._onFieldUpdate;
    var onKeyDown = function (evt) {
        if (evt.key === 'Enter') {
            _onFieldUpdate(itemId, extractor(evt));
        }
    };
    return {
        onKeyDown: onKeyDown,
    };
}
//# sourceMappingURL=useOnKeyDown.js.map